
import banner from "../images/models/banner.png";
import { useTranslation } from 'react-i18next';

function How() {
      const { t, i18n } = useTranslation();
      const currentLanguage = i18n.language;

      const getImagePath = (index) => {
            const langCode = currentLanguage === 'tr-TR' ? 'tr' : currentLanguage;
            return require(`../images/slider-${langCode}/${index}.png`);
      };

      const howData = [
            {
                  id: 1,
                  title: t('how.step1.title'),
                  description: t('how.step1.description'),
                  isImageRight: true
            },
            {
                  id: 2,
                  title: t('how.step2.title'),
                  description: t('how.step2.description'),
                  isImageRight: false
            },
            {
                  id: 3,
                  title: t('how.step3.title'),
                  description: t('how.step3.description'),
                  isImageRight: true
            },
            {
                  id: 4,
                  title: t('how.step4.title'),
                  description: t('how.step4.description'),
                  isImageRight: false
            },
            {
                  id: 5,
                  title: t('how.step5.title'),
                  description: t('how.step5.description'),
                  isImageRight: true
            },
            {
                  id: 6,
                  title: t('how.step6.title'),
                  description: t('how.step6.description'),
                  isImageRight: false
            },
            {
                  id: 7,
                  title: t('how.step7.title'),
                  description: t('how.step7.description'),
                  isImageRight: true
            },
            {
                  id: 8,
                  title: t('how.step8.title'),
                  description: t('how.step8.description'),
                  isImageRight: false
            },
            {
                  id: 9,
                  title: t('how.step9.title'),
                  description: t('how.step9.description'),
                  isImageRight: true
            },
            {
                  id: 10,
                  title: t('how.step10.title'),
                  description: t('how.step10.description'),
                  isImageRight: false
            }
      ].map((item, index) => ({
            ...item,
            image: getImagePath(index + 1)
      }));

      return (
            <div className="how-section" style={{ padding: "15rem 0" }}>
                  <div style={{ textAlign: "center", marginBottom: "2rem" }}>

                  </div>

                  <h1 style={{ fontSize: "3.5rem", textAlign: "center", marginBottom: "5rem" }}>{t('how.title')}</h1>

                  <div className="container">
                        {howData.map((item) => (
                              <div
                                    key={item.id}
                                    style={{
                                          display: "flex",
                                          alignItems: "flex-start",
                                          gap: "5rem",
                                          marginBottom: "8rem",
                                          flexDirection: item.isImageRight ? "row" : "row-reverse"
                                    }}
                              >
                                    <div style={{ flex: 1 }}>
                                          <span style={{ fontSize: "2rem", color: "#ff4d30", display: "block", marginBottom: "1rem" }}>{t('how.step')} {item.id}</span>
                                          <h2 style={{ fontSize: "2.4rem", fontWeight: "bold", marginBottom: "2rem" }}>{item.title}</h2>
                                          <p style={{ fontSize: "1.6rem", color: "#706f7b" }}>{item.description}</p>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                          <img
                                                src={item.image}
                                                alt={item.title}
                                                style={{
                                                      width: "100%",
                                                      height: "400px",
                                                      objectFit: "cover",
                                                      borderRadius: "10px"
                                                }}
                                          />
                                    </div>
                              </div>
                        ))}
                  </div>
                  <div style={{
                        marginTop: "5rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "5rem",
                        backgroundColor: "#f8f8f8",
                        padding: "4rem",
                        borderRadius: "10px"
                  }}>
                        <div style={{ flex: 1 }}>
                              <h2 style={{
                                    fontSize: "2.8rem",
                                    marginBottom: "2rem",
                                    color: "#ff4d30"
                              }}>
                                    {t('how.finalOverview')}
                              </h2>
                              <p style={{
                                    fontSize: "1.6rem",
                                    color: "#706f7b",
                                    lineHeight: "1.6"
                              }}>
                                    {t('how.finalDescription')}
                              </p>
                        </div>
                        <div style={{ flex: 1 }}>
                              <img
                                    src={banner}
                                    alt="platform overview"
                                    style={{
                                          width: "100%",
                                          objectFit: "cover",
                                          borderRadius: "10px"
                                    }}
                              />
                        </div>
                  </div>
                  <div className="iframe-container" style={{ position: "relative", overflow: "hidden", width: "100%", paddingTop: "56.25%", borderRadius: "15px" }}>
                        <iframe
                              src="https://panel.exvrtise.com/carviewer/start/65e0345c79c45a912643415c"
                              style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%", border: "none", padding: "5rem" }}
                              title="360 Vehicle Inspection"
                              allowFullScreen
                        />
                  </div>
                  <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "3rem",
                        marginTop: "5rem",
                        padding: "0 5rem"
                  }}>
                        <div className="iframe-container" style={{ position: "relative", overflow: "hidden", width: "100%", paddingTop: "56.25%", borderRadius: "15px" }}>
                              <iframe
                                    src="https://panel.exvrtise.com/carviewer/view/65e0345c79c45a912643415c"
                                    style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%", border: "none" }}
                                    title="360 Vehicle Inspection"
                                    allowFullScreen
                              />
                        </div>
                        <div className="iframe-container" style={{ position: "relative", overflow: "hidden", width: "100%", paddingTop: "56.25%", borderRadius: "15px" }}>
                              <iframe
                                    src="https://panel.exvrtise.com/carviewer/360/65e0345c79c45a912643415c"
                                    style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%", border: "none" }}
                                    title="360 Vehicle Inspection"
                                    allowFullScreen
                              />
                        </div>
                  </div>

            </div>
      );
}

export default How;